<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'600px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal">

    <template v-slot:Body>
      <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

      <div class="col-md-12">
        <div style="float: left;font-size:14px;padding-top: 5px;width:21%;text-align: right; padding-right: 15px;min-width:30px">
          <label>{{ this.GetTraduzioneLabel('Generic','TKN_STORICO_DAL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:left;width:12%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.DallaData"/>
        </div>
        
        <div style="float:left;width:10%;">&nbsp;</div>
        <div style="float:left;font-size:14px;padding-top: 5px;width:10%;text-align: right; padding-right: 15px;">
          <label style="float:left;min-width:20px;width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_AL',this.LinguaUtente) }}</label>
        </div>
        <div style="float:left;width:12%">
          <input type="date" class="form-control" style="min-width:132px" v-model="Filtro.AllaData"/>
        </div>
        
        <div style="float:left;width:3%;">&nbsp;</div>
        <div style="clear:both;height:10px"></div>
      </div>



      <div class="col-md-12">
        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="width:57%;float:left;">
          <div class="ZMSeparatoreScheda" style="width:40%;float:left;margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('Generic','TKN_MODULI',this.LinguaUtente) }}</text>
          </div>
          <div class="ZMSeparatoreScheda" style="width:60%;float:left;margin-bottom:0px;margin-top:0px" :style="{'background-color' : ColoriPantone.Marrone }">       
            <text style="font-weight: bold;">{{ this.GetTraduzioneLabel('Generic','TKN_COLORE',this.LinguaUtente) }}</text>
          </div>
          <div style="clear:both"></div>
          <div style="overflow:auto; max-height: 300px">
            <template v-for="(OggettoModulo, index) in FiltraModuli" :key="index">
              <!-- <div style="" :style="{'background-color' : index % 2 == 0? ColoriSfondo.Arancione : 'white' }"> -->
              <div style="background-color:white;">
                <div style="float:left;width:3%;">&nbsp;</div>
                <input style="float:left;width:3%;margin-top:5px;padding: 0px;height: 20px" type="checkbox" class="form-control" v-model="OggettoModulo.Selezionato"/>
                <div style="float:left;width:2%;">&nbsp;</div>
                <text style="float:left;width:40%;margin-top:3px;font-size:16px"> {{ this.GetTraduzioneLabel('Generic','TKN_MOD_N',this.LinguaUtente) }} {{ OggettoModulo.Id }}</text>
                <div style="float:left;width:52%;margin-top:4px;text-align:center">
                  <div style="float:left;width:27%;">&nbsp;</div>
                  <div class="ZMColorPickerDiv" :style="{'background-color' : OggettoModulo.Colore, 'width' : '53%', 'float' : 'left'}" @click="ApriPopupColorPicker(OggettoModulo)">&nbsp;</div>
                  <div style="float:left;width:10%;">&nbsp;</div>
                </div>
                <div style="clear:both"></div>
              </div>
            </template>
          </div>
        </div>
        
        <div style="float:left;width:2%;">&nbsp;</div>

        <div style="width:35%;float:left" ref="DivPulsanti">
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickSelezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_TUTTI',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickDeselezionaTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_NESSUNO',this.LinguaUtente) }}</button>
          </div>
          <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button @click="OnClickInvertiTuttiModuli" type="button" class="btn btn-info" style="width:100%">{{ this.GetTraduzioneLabel('Generic','TKN_INVERTI',this.LinguaUtente) }}</button>
          </div>
          <!-- <div style="clear:both;height:4px"></div>
          <div style="float:left;width:4%;">&nbsp;</div>
          <div style="float:left;width:96%">
            <button type="button" class="btn btn-info" style="width:100%">Colore</button>
          </div> -->
          <div style="clear:both;height:10px"></div>

          <!-- <div>
            <div style="float:left;width:4%;">&nbsp;</div>
            <div style="float:left;width:6%;">
              <input style="float:left;height:100%" type="checkbox" class="form-control" v-model="Filtro.Markup"/>
            </div> 
            <div style="float:left;width:90%;">
              <label style="float:left;font-weight:bold;font-size:16px;margin-bottom:4px">&nbsp;&nbsp;&nbsp;Markup</label>
            </div> 
            <div class="ZMDistanziatore"></div>
          </div> -->

        </div>

        <div style="float:left;width:3%;">&nbsp;</div>

        <div style="clear:both;height:4px"></div>

      </div>
      <div class="col-md-12" v-if="ConteggioNumeroSelezionati()">
        <div style="float:left;width:3%;">&nbsp;</div>
        <label style="font-size:18px" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('VUEPopupTensioneAssorbimento','TKN_POPUP_ASS_LIMITE',this.LinguaUtente) }}</label>
      </div>
    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanConfirm()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>
</template>

<script>

import VUEModal from '@/utils/VUEModal.vue';            
import { COLORI_PANTONE, SystemInformation, TIPOLOGIA_GRAFICI_STORICI, SFONDO, TInfoGraficiStorici, LOCALSTORAGE } from '@/SystemInformation'
import { TZDateFunct } from '@/utils/ZDateFunct.js'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import MixInsDoubleClickHandler from '@/views/ContentPages/MixInsDoubleClickHandler';
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';

export default 
{
  data()
  {
   return {
            ColoriPantone         : COLORI_PANTONE,
            ColoriSfondo          : SFONDO,
            TipologiaGrafici      : TIPOLOGIA_GRAFICI_STORICI,
            TipologiaPopup        : SystemInformation.TipoPopupAperto,
            Filtro                : {
                                      Markup : false,
                                    },
            GrandezzaDivPulsanti  : {
                                      Height : 0
                                    },
            URLSchedaStorici      : '/appMainWindow/GraficiStorici',
            PopupColorPicker      : false,
            ColoreInModifica      : { 
                                      Colore           : '#000000',
                                      ModuloInModifica : null 
                                    },
            LinguaUtente : SystemInformation.UserInformation.Lingua
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjCatena', 'VettoreModuli'],
  emits : ['OnClickChiudiPopup'],
  mixins: [MixInsDoubleClickHandler, MixInsGestioneTraduzioni],
  components: { VUEModal, VUEColorPicker },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickConfermaModal()
    {
      let ModuliSelezionati = this.FiltraModuli.filter((element) => {return element.Selezionato})
      SystemInformation.OggettoInfoGraficiStorici = new TInfoGraficiStorici(this.ObjCatena.DatiCatena.CHIAVE_SITO, 
                                                                            this.ObjCatena.DatiCatena.CHIAVE,
                                                                            this.ObjCatena.Descrizione,
                                                                            this.TipologiaPopup,
                                                                            ModuliSelezionati, 
                                                                            new Date(this.Filtro.DallaData), 
                                                                            new Date(this.Filtro.AllaData), 
                                                                            this.Filtro.OreDal, 
                                                                            this.Filtro.OreAl,
                                                                            this.Filtro.VisualizzaMarkup,
                                                                            this.Filtro.InterpMinimiQuadrati,
                                                                            this.Filtro.OrientamentoAsse,
                                                                            this.Filtro.PeriodoMedia)
      
      if(this.Filtro.AllineamentoIncl != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoIncl     = this.Filtro.AllineamentoIncl
      if(this.Filtro.AllineamentoTemp != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoTemp     = this.Filtro.AllineamentoTemp
      if(this.Filtro.AllineamentoDef != null)
        SystemInformation.OggettoInfoGraficiStorici.AllineamentoDef      = this.Filtro.AllineamentoDef
      
      SystemInformation.OggettoInfoGraficiStorici.UrlRitornoAllaCatena   = this.$route.fullPath
      
      localStorage.removeItem(LOCALSTORAGE.OggettoInfoGraficiStorici);
      localStorage.setItem(LOCALSTORAGE.OggettoInfoGraficiStorici, JSON.stringify(SystemInformation.OggettoInfoGraficiStorici));

      this.$router.push(this.URLSchedaStorici)
    },

    OnClickSelezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = true
        });
      }
    },

    OnClickDeselezionaTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = false
        });
      }
    },

    OnClickInvertiTuttiModuli()
    {
      if(this.FiltraModuli.length != 0)
      {
        this.FiltraModuli.forEach(function(Modulo)
        { 
            Modulo.Selezionato = !Modulo.Selezionato
        });
      }
    },

    CalcolaGrandezzaDivPulsanti()
    {
      this.GrandezzaDivPulsanti.Height = this.$refs.DivPulsanti.clientHeight
    },

    GetAWeekAgo()
    {
      var date = new Date();
      date.setDate(date.getDate() - 7);
      return date
    },

    ControlloDateInserite()
    {
      if(this.Filtro.DallaData != '' && this.Filtro.AllaData != '' && this.Filtro.OreDal !== '' && this.Filtro.OreAl !== '')
      {
        if(this.Filtro.DallaData + ' ' + this.Filtro.OreDal < this.Filtro.AllaData + ' ' + this.Filtro.OreAl)
          return true
      }
      return false
    },

    ControlloModuliSelezionati()
    {
      for(let i = 0; i < this.FiltraModuli.length; i++)
      {
        if(this.FiltraModuli[i].Selezionato)
          return true
      }
      return false
    },

    CanConfirm()
    {
      // return false
      return this.ControlloDateInserite() &&
             this.ControlloModuliSelezionati() &&
             !this.ConteggioNumeroSelezionati()
             
    },

    GestisciDateGrafica(Data)
    {
      return TZDateFunct.FormatDateTime('dd/mm/yyyy', new Date(Data))
    },

    ConteggioNumeroSelezionati()
    {
      let Result = 0
      for(let i = 0; i < this.FiltraModuli.length; i++)
      {
        if(this.FiltraModuli[i].Selezionato)
          Result++
      }
      if(Result > 27)
        return true
      return false
    },

    ApriPopupColorPicker(Modulo)
    {
      this.ColoreInModifica.Colore = Modulo.Colore
      this.ColoreInModifica.ModuloInModifica = Modulo
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ColoreInModifica.ModuloInModifica.Colore = this.ColoreInModifica.Colore
      this.AnnullaColore()
      this.Repaint++
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

  },
  
  computed:
  {
    FiltraModuli :
    {
      get()
      {
        let Self   = this
        let Result = []
        Result     = this.VettoreModuli
      
        if(this.Filtro.Estensimetri || this.Filtro.Piezometri)
        {
          Result = Result.filter(function(Modulo)
          {
            if(Self.Filtro.Piezometri && Modulo.Piezometro)
              return true
            if(Self.Filtro.Estensimetri && Modulo.Estensimetro)
              return true
            return false
          })
        }

        return Result
      }
    }
  },

  beforeMount()
  {
    this.Filtro.AllaData  = TZDateFunct.FormatDateTime('yyyy-mm-dd',new Date())
    this.Filtro.DallaData = TZDateFunct.FormatDateTime('yyyy-mm-dd',this.GetAWeekAgo())
  },

  mounted()
  {
    this.CalcolaGrandezzaDivPulsanti()
  },
}
</script>